var _line, _line2, _g, _g2, _g3, _g4, _g5, _line3, _line4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVideoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 870,
    height: 600,
    viewBox: "0 0 870 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 725.618,
    y1: 537.322,
    x2: 450.618,
    y2: 211.322,
    stroke: "#17191D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 472.852,
    y1: 143.522,
    x2: 801.852,
    y2: 41.5224,
    stroke: "#17191D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.647 36.66C807.371 34.373 807.371 28.627 811.647 26.34L843.433 9.33744C847.691 7.05995 853 9.92344 853 14.4974V48.5026C853 53.0764 847.691 55.9401 843.433 53.6623L811.647 36.66Z",
    fill: "url(#paint0_linear_133_243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.353 26.34C864.629 28.627 864.629 34.373 860.353 36.66L828.567 53.6623C824.309 55.9401 819 53.0764 819 48.5026V14.4974C819 9.92341 824.309 7.05996 828.567 9.33744L860.353 26.34Z",
    fill: "url(#paint1_linear_133_243)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    clipPath: "url(#clip0_133_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.314 178.264C367.083 174.379 367.083 164.62 374.314 160.736L428.071 131.859C435.272 127.991 444.25 132.854 444.25 140.623V198.377C444.25 206.146 435.272 211.009 428.071 207.141L374.314 178.264Z",
    fill: "url(#paint2_linear_133_243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.686 160.736C463.916 164.62 463.916 174.379 456.686 178.264L402.929 207.141C395.729 211.009 386.75 206.146 386.75 198.377V140.623C386.75 132.854 395.729 127.991 402.929 131.859L456.686 160.736Z",
    fill: "url(#paint3_linear_133_243)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.384,
    y1: 219.679,
    x2: 716.384,
    y2: 536.679,
    stroke: "#16191C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.386,
    y1: 212.682,
    x2: 721.386,
    y2: 536.682,
    stroke: "#171A1E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.788 573.242C719.45 570.919 719.45 565.082 723.788 562.758L756.042 545.486C760.363 543.172 765.75 546.081 765.75 550.728V585.273C765.75 589.919 760.363 592.828 756.042 590.514L723.788 573.242Z",
    fill: "url(#paint4_linear_133_243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.212 562.758C777.55 565.082 777.55 570.919 773.212 573.242L740.958 590.514C736.637 592.828 731.25 589.919 731.25 585.273V550.728C731.25 546.081 736.637 543.172 740.958 545.486L773.212 562.758Z",
    fill: "url(#paint5_linear_133_243)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.668 468.604C185.712 467.006 185.712 462.993 188.668 461.396L210.638 449.521C213.581 447.931 217.25 449.931 217.25 453.125V476.875C217.25 480.069 213.581 482.069 210.638 480.478L188.668 468.604Z",
    fill: "url(#paint6_linear_133_243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.332 461.396C225.288 462.993 225.288 467.006 222.332 468.604L200.362 480.478C197.419 482.069 193.75 480.069 193.75 476.875V453.125C193.75 449.931 197.419 447.931 200.362 449.521L222.332 461.396Z",
    fill: "url(#paint7_linear_133_243)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    clipPath: "url(#clip1_133_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3211 79.1904C8.53061 75.5602 8.53067 66.4395 15.3212 62.8094L65.8055 35.8213C72.5683 32.2062 81.0001 36.7514 81.0001 44.0117V97.9882C81.0001 105.248 72.5683 109.794 65.8055 106.178L15.3211 79.1904Z",
    fill: "url(#paint8_linear_133_243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6789 62.8095C99.4692 66.4395 99.4692 75.5602 92.6789 79.1904L42.1944 106.178C35.432 109.794 27 105.248 27 97.9882V44.0117C27 36.7514 35.432 32.2062 42.1944 35.8213L92.6789 62.8095Z",
    fill: "url(#paint9_linear_133_243)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.4646,
    y1: 117.815,
    x2: 195.465,
    y2: 439.815,
    stroke: "#181B1F"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 83.4712,
    y1: 121.833,
    x2: 194.471,
    y2: 434.833,
    stroke: "#17191D"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 224.591,
    y1: 434.712,
    x2: 378.591,
    y2: 215.712,
    stroke: "#17191D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_243",
    x1: 802,
    y1: 31.5,
    x2: 870,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#4A4747",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_243",
    x1: 870,
    y1: 31.5,
    x2: 802,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_243",
    x1: 358,
    y1: 169.5,
    x2: 473,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#4A4747",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_243",
    x1: 473,
    y1: 169.5,
    x2: 358,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_133_243",
    x1: 714,
    y1: 568,
    x2: 783,
    y2: 568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#4A4747",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_133_243",
    x1: 783,
    y1: 568,
    x2: 714,
    y2: 568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_133_243",
    x1: 182,
    y1: 465,
    x2: 229,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#4A4747",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_133_243",
    x1: 229,
    y1: 465,
    x2: 182,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_133_243",
    x1: 0.0000438132,
    y1: 70.9999,
    x2: 108,
    y2: 70.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#4A4747",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_133_243",
    x1: 108,
    y1: 70.9999,
    x2: 0.0000095299,
    y2: 70.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 107,
    fill: "white",
    transform: "translate(358 116)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_133_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 100,
    fill: "white",
    transform: "translate(0 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideoBackground);
export default __webpack_public_path__ + "static/media/noVideoBackground.707fd54854e2f070ff66c64ea5b10079.svg";
export { ForwardRef as ReactComponent };